import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        data-name="Icon awesome-medal"
        d="M10.488 6.129 7.248.728A1.5 1.5 0 0 0 5.962 0H.751a.75.75 0 0 0-.614 1.18l5.216 7.452a9.7 9.7 0 0 1 5.135-2.503zM23.249 0h-5.21a1.5 1.5 0 0 0-1.286.728l-3.24 5.4a9.7 9.7 0 0 1 5.136 2.5l5.214-7.448A.75.75 0 0 0 23.249 0zM12 7.5a8.25 8.25 0 1 0 8.25 8.25A8.25 8.25 0 0 0 12 7.5zm4.337 7.372L14.559 16.6l.42 2.448a.538.538 0 0 1-.78.567L12 18.463l-2.2 1.156a.538.538 0 0 1-.78-.567l.42-2.448-1.776-1.732a.538.538 0 0 1 .3-.918l2.458-.358 1.1-2.228a.539.539 0 0 1 .966 0l1.1 2.228 2.458.358a.538.538 0 0 1 .291.918z"
      />
    </svg>
  )
}

type MedalIconProps = SvgIconProps

export const MedalIcon: React.FC<MedalIconProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 24 24" focusable="false" aria-hidden="true" />
}
